export default {
  getDocumentStatuses: (state) => state.documentStatuses,
};
